import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateApplicationComponent } from './create-application/create-application.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    CreateApplicationComponent
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule
  ]
})
export class ZypeModule { }
